import { disciplineByKey } from 'constants/disciplines';
import Immutable from 'immutable';
import { Discipline, DisciplineDesignator } from 'records/Discipline';

type DisciplineKeys = Extract<keyof typeof disciplineByKey, string>;

export type SheetSortFields =
  | 'originalOrder'
  | 'publishedDate'
  | 'uploadedDate'
  | 'title'
  | 'number'
  | 'discipline';

export interface RawSheetQuery {
  sortField: SheetSortFields;
  sortDirection: 'ascending' | 'descending';
  search: string;
  disciplines: DisciplineKeys[];
  disciplineSearch: string;
  sheetDisciplines: Immutable.OrderedMap<DisciplineDesignator, Discipline>;
  revisionComments: string[];
  recentlyIssued: boolean;
  initialized: boolean;
}

export interface SheetQueryData {
  sortField: SheetSortFields;
  sortDirection: 'ascending' | 'descending';
  search: string;
  disciplines: Immutable.Set<DisciplineKeys>;
  disciplineSearch: string;
  sheetDisciplines: Immutable.OrderedMap<DisciplineDesignator, Discipline>;
  revisionComments: Immutable.Set<string>;
  recentlyIssued: boolean;
  initialized: boolean;
}

const defaultValues: SheetQueryData = {
  sortField: 'discipline',
  sortDirection: 'ascending',
  search: '',
  disciplines: Immutable.Set<DisciplineKeys>(),
  disciplineSearch: '',
  sheetDisciplines: Immutable.OrderedMap<DisciplineDesignator, Discipline>(),
  revisionComments: Immutable.Set<string>(),
  recentlyIssued: false,
  initialized: false,
};

export const SheetQueryFactory = Immutable.Record(defaultValues, 'SheetQuery');

export class SheetQuery extends SheetQueryFactory {
  static deserialize(rawSheetQuery: RawSheetQuery): SheetQuery {
    return new SheetQuery({
      ...rawSheetQuery,
      disciplines: Immutable.Set(rawSheetQuery.disciplines),
      revisionComments: Immutable.Set(rawSheetQuery.revisionComments),
    });
  }

  serialize(): RawSheetQuery {
    return this.toJS();
  }
}
